import { useDispatch } from 'react-redux';
import { AppDispatch } from 'types/redux';

const useAppDispatch = () => useDispatch<AppDispatch>();

export default useAppDispatch;
